var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg",
    "data-name": "Icon Bg",
    width: 114,
    height: 114,
    rx: 8,
    transform: "translate(-16 -16)",
    fill: "#3571ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497828",
    "data-name": "Path 497828",
    d: "M3.2,35.348a5.675,5.675,0,0,0,5.673,5.673h5.673V37.24H8.873a1.9,1.9,0,0,1-1.891-1.891V8.873A1.9,1.9,0,0,1,8.873,6.982H35.348A1.9,1.9,0,0,1,37.24,8.873v5.673H20.22a5.675,5.675,0,0,0-5.673,5.673V46.7a5.675,5.675,0,0,0,5.673,5.673H46.7A5.675,5.675,0,0,0,52.368,46.7V20.22A5.675,5.675,0,0,0,46.7,14.547H41.022V8.873A5.675,5.675,0,0,0,35.348,3.2H8.873A5.675,5.675,0,0,0,3.2,8.873ZM18.329,20.22a1.9,1.9,0,0,1,1.891-1.891H46.7a1.9,1.9,0,0,1,1.891,1.891V46.7A1.9,1.9,0,0,1,46.7,48.586H20.22A1.9,1.9,0,0,1,18.329,46.7Z",
    transform: "translate(13.211 13.211)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497829",
    "data-name": "Path 497829",
    d: "M0,0H56.995V56.995H0Z",
    transform: "translate(12.497 12.497)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy1);
export default __webpack_public_path__ + "static/media/copy1.4b011469f3f57d2c9945a957099396e0.svg";
export { ForwardRef as ReactComponent };